<template>
    <div class="main-content">
        <section class="home-footer">
            <div class='footer-app-card'>
                <div class="footer-app-info">
                    <div class="footer-app-brand-area">
                        <img src="@/assets/icons/iconApp.svg" alt="App" class="app-svg" />
                        <p>{{ AppEssentials.AppName }} </p>
                    </div>
                    <div class="footer-app-slogen-area">
                        <p>Your Professional </p>
                        <p>AI Voice Creation</p>
                        <p>Toolkit</p>
                    </div>
                </div>
                <div class="footer-app-links">
                    <a href="https://x.com/" target="_blank" rel="noopener">
                        <img src="@/assets/icons/iconX.svg" alt="iconX" class="social-svg" />
                    </a>
                    <a href="https://www.facebook.com/" target="_blank" rel="noopener">
                        <img src="@/assets/icons/iconFacebook.svg" alt="iconFacebook" class="social-svg" />
                    </a>
                    <a href="https://www.youtube.com/" target="_blank" rel="noopener">
                        <img src="@/assets/icons/iconYoutube.svg" alt="iconYoutube" class="social-svg" />
                    </a>
                    <a href="https://www.linkedin.com/" target="_blank" rel="noopener">
                        <img src="@/assets/icons/iconLinkedin.svg" alt="iconLinkedin" class="social-svg" />
                    </a>
                </div>
            </div>
            <div class='footer-navi-card'>
                <div class="footer-navi-list">
                    <p>Product</p>
                    <button type="button" @click="goToFeature('/voice-gallery', 'Voice Gallery')">Voice Gallery</button>
                    <button type="button" @click="goToFeature('/voice-designer', 'Voice Designer')">Voice Designer</button>
                    <button type="button" @click="goToFeature('/text-to-speech-projects', 'Text to Speech')">Text To Speech</button>
                </div>
                <div class="footer-navi-list">
                    <p>Payment</p>
                    <router-link to="/pricing">Pricing</router-link>
                    <button type="button" @click="goToFeature('/credit', 'Credit')">Credit</button>
                </div>
                <div class="footer-navi-list">
                    <p>Account</p>
                    <button type="button" @click="goToFeature('/profile', 'Profile')">Profile</button>
                    <button type="button" @click="goToFeature('/referral', 'Referral')">Referral</button>
                </div>
                <div class="footer-navi-list">
                    <p>About</p>
                    <a href="/TOU.html" target="_blank" rel="noopener">Terms of Use</a>
                    <a href="/PrivacyPolicy.html" target="_blank" rel="noopener">Privacy Policy</a>
                    <a href="/PaymentPolicy.html" target="_blank" rel="noopener">Payment Policy</a>
                    <router-link to="/About">About {{ AppEssentials.AppName }}</router-link>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import AppEssentials from '@/data/AppEssentials.js'
import { inject } from 'vue'
import { useRouter } from 'vue-router'
export default {
    name: "HomeFooterView",
    setup() {
        const router = useRouter()
        const keycloak = inject('keycloak')

        function goToFeature(path, action) {
            const authToken = localStorage.getItem('auth_token') || ''
            if (!authToken) {
                console.log(`Auth required for ${action}; redirecting to login...`)
                keycloak.login()
                return
            }
            router.push({ path })
        }

        return {
            AppEssentials,
            goToFeature,
        };
    },
};
</script>
<style scoped>
.home-footer {
    background-color: var(--purple-footer-dark);
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: clamp(2rem, 5vw, 5rem);
    padding: 2rem clamp(1.5rem, 5vw, 4rem) 3rem;
}

.footer-app-card {
    flex: 0 1 360px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem clamp(1rem, 2vw, 2rem);
}

.footer-app-info {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.footer-app-brand-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: 16px;
    margin-right: 16px;
    border-right: 1px solid var(--border-color);
    height: 100%;
}

.footer-app-brand-area p {
    color: white;
    font-weight: 600;
    font-size: 1.25rem;
    margin: 8px 0 0 0;
}

.footer-app-brand-area .app-svg {
    width: 42px;
    height: 42px;
    display: block;
    transition: filter 0.3s, color 0.3s;
    filter: brightness(0) invert(1);
}

.footer-app-slogen-area p {
    color: white;
    font-weight: 600;
    font-size: 1.25rem;
    margin: 8px 0 0 0;
}

.footer-app-links {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 16px;
    gap: clamp(1rem, 3vw, 2rem);
}

.footer-app-links .social-svg {
    width: 32px;
    height: 32px;
    display: block;
    filter: brightness(0) invert(1);
    cursor: pointer;
}

.footer-navi-card {
    flex: 1 1 620px;
    min-width: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(136px, 1fr));
    align-items: flex-start;
    column-gap: clamp(2rem, 4vw, 4rem);
    row-gap: 2rem;
    padding-top: 2rem;
    padding-inline: clamp(1rem, 3vw, 3rem);
}

.footer-navi-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    min-width: 0;
    padding-inline: clamp(0.5rem, 1vw, 1rem);
}

.footer-navi-list p {
    font-weight: 500;
    color: white;
}

.footer-navi-list a,
.footer-navi-list button {
    color: #fff;
    text-decoration: none;
    font-weight: 200;
    transition: color 0.2s;
    border: 0;
    padding: 0;
    background: transparent;
    cursor: pointer;
    font: inherit;
    text-align: left;
    overflow-wrap: anywhere;
}

.footer-navi-list a:hover,
.footer-navi-list button:hover {
    color: var(--purple);
}

@media (max-width: 980px) {
    .home-footer {
        flex-direction: column;
    }

    .footer-app-card,
    .footer-navi-card {
        flex-basis: auto;
        width: 100%;
    }

    .footer-navi-card {
        padding-inline: 0;
    }
}

@media (max-width: 520px) {
    .footer-app-info {
        align-items: flex-start;
        flex-direction: column;
        gap: 1rem;
    }

    .footer-app-brand-area {
        align-items: flex-start;
        padding-right: 0;
        margin-right: 0;
        border-right: 0;
    }

    .footer-navi-card {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 1.25rem;
        row-gap: 1.75rem;
    }

    .footer-navi-list {
        padding-inline: 0.25rem;
    }
}
</style>
